import { render, staticRenderFns } from "./VendorOpenDialog.vue?vue&type=template&id=99b6d0a6&scoped=true"
import script from "./VendorOpenDialog.vue?vue&type=script&lang=js"
export * from "./VendorOpenDialog.vue?vue&type=script&lang=js"
import style0 from "./VendorOpenDialog.vue?vue&type=style&index=0&id=99b6d0a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b6d0a6",
  null
  
)

export default component.exports